import { InfoCircleFilled } from '@ant-design/icons';
import { FormInstance } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import { NouveauDossierConcessionnaireData } from 'types/Concessionnaire';
import { isM1TraEq114PersonneMorale } from 'views/dossiers/concessionnaire/steps/step2/step2.selectors';

export default function BonificationTaxiBanner({
  form,
}: {
  form: FormInstance<NouveauDossierConcessionnaireData>;
}) {
  const { t } = useTranslation();

  if (
    !isM1TraEq114PersonneMorale(
      form.getFieldValue('typeClientFinal'),
      form.getFieldValue('categorieVehicule'),
    )
  ) {
    return null;
  }

  return (
    <div className="bg-bleu-hellio-1 py-3 pl-6 pr-4">
      <p className="mb-0 flex items-start gap-2 text-gris-hellio-6">
        <InfoCircleFilled className="mt-[4px] text-bleu-hellio-6" />
        <span>
          <span className="block font-semibold text-bleu-hellio-6">
            {t('nouveau_formulaire:resultat:bonification_taxi_titre')}
          </span>
          <Trans
            i18nKey="nouveau_formulaire:resultat:bonification_taxi_description"
            components={{ sup: <sup /> }}
          />
        </span>
      </p>
    </div>
  );
}
